import { Alert, Box, Button, Link } from '@mui/material'
import Header from 'components/Header'
import Loading from 'components/Loading'
import { useAPI } from 'contexts/APIProvider'
import { useMixpanel } from 'contexts/MixpanelProvider'
import { isEmpty } from 'lodash'
import React from 'react'
import { useNavigate } from 'react-router'
import { practiceSignupAddJobURL } from 'routes/urls'
import PracticeSignupContext from '../context'
import Job from 'logic/Job';
import JobCard from 'pages/PracticeSignup/JobPosting/JobCard'

const PracticeSignupJobList: React.FC = () => {
	const { toNextStep, toPreviousStep, jobs, reloadJobs, trackOnce } = React.useContext(PracticeSignupContext)
  const { track } = useMixpanel()
  const { api } = useAPI()
  const navigate = useNavigate()

  const toAddJobPage = () => navigate(practiceSignupAddJobURL())

  const cancelJob = async (job: Job) => {
    await api.cancelJob(job.job_id, { reason: 'Cancel job during practice signup.' })
    track('practice_signup_v1_job_cancelled')
    await reloadJobs()
  }

  React.useEffect(() => {
    if (jobs === undefined) return
    if (isEmpty(jobs)) {
      toAddJobPage()
    }
  }, [jobs])

  // Guarded on a non-empty list: this component redirects to JobAdd when there are no
  // jobs yet, so an unguarded event would fire for every first-time signup - before
  // job_add_step_reached - and invert the funnel.
  React.useEffect(() => {
    if (jobs === undefined || isEmpty(jobs)) return
    trackOnce('practice_signup_v1_job_list_step_reached')
  }, [jobs, trackOnce])

  if (jobs === undefined) return <Loading />

  const toPaymentStep = () => {
    track('practice_signup_v1_job_posting_completed', { job_count: jobs.length })
    toNextStep()
  }

  return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2, overflowY: 'auto' }}>
      <Header variant='h3' text='Job Posts'></Header>
      {jobs.map(job => <JobCard key={job.job_id} job={job} cancelJob={cancelJob} />)}
      <Button variant="contained" color="primary" onClick={toPaymentStep}>Select Payment</Button>
      <Button variant="outlined" color="primary" onClick={toAddJobPage}>Add Another Job</Button>
      <Button variant="outlined" color="primary" onClick={toPreviousStep}>Back</Button>
    </Box>
	)
}

export default PracticeSignupJobList